import invert from 'lodash/invert';

const PATH_PRE_FIX = '/g/hotel-unified-bff';

const MIN_POLL_INTERVAL = 500;

const TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_NOT_INCLUDED =
  'TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_NOT_INCLUDED' as const;
const TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_INCLUDED =
  'TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_INCLUDED' as const;
const TAX_AND_FEE_INCLUSION_POLICY_FEES_INCLUDED =
  'TAX_AND_FEE_INCLUSION_POLICY_FEES_INCLUDED' as const;

// https://skyscanner.atlassian.net/wiki/x/6hMqR - UBFF Error Codes for reference
const CODE_BAD_REQUEST = 3;
const CODE_UNEXPECTED_ERROR = 13;
const CODE_JWT_VERRIFY_FAILURE = 16;

const PRICE_TYPE_PER_NIGHT = 'PRICE_TYPE_PER_NIGHT' as const;
const PRICE_TYPE_TOTAL = 'PRICE_TYPE_TOTAL' as const;

const PRICE_TYPE_MAPPING = {
  [PRICE_TYPE_TOTAL]: 'total',
  [PRICE_TYPE_PER_NIGHT]: 'price-per-night',
};

const UBFF_PRICE_TYPE_MAPPING = invert(PRICE_TYPE_MAPPING);

const BREAK_POLLING_CODES = [
  CODE_BAD_REQUEST,
  CODE_UNEXPECTED_ERROR,
  CODE_JWT_VERRIFY_FAILURE,
];

const SKYSCANNER_CORRELATION_ID = 'Skyscanner-Correlation-ID';

export {
  PATH_PRE_FIX,
  MIN_POLL_INTERVAL,
  PRICE_TYPE_TOTAL,
  PRICE_TYPE_PER_NIGHT,
  BREAK_POLLING_CODES,
  PRICE_TYPE_MAPPING,
  UBFF_PRICE_TYPE_MAPPING,
  SKYSCANNER_CORRELATION_ID,
  TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_NOT_INCLUDED,
  TAX_AND_FEE_INCLUSION_POLICY_TAXES_FEES_INCLUDED,
  TAX_AND_FEE_INCLUSION_POLICY_FEES_INCLUDED,
};
